import { createSlice } from "@reduxjs/toolkit";
import { ValidityPeriodInterface } from "../../common/interfaces/ValidityPeriodInterface";
import { QualificationValidityTypeEnum } from "../../common/enums/QualificationValidityTypeEnum";

interface EditCertificateModalInterface {
    isEditCertificateModalOpen: boolean;
    isPatchEditCertificateSuccess: boolean;
    selectedCertificateId?: number;
    formValues?: {
        qualification: {
            selectedId: string;
            selectedValue: string;
            validityPeriod: ValidityPeriodInterface | null;
            validityType: QualificationValidityTypeEnum | null;
            fixedValidUntil: string | null;
        };
        educator?: {
            selectedId: string;
            selectedValue: string;
        };
        employee: [selectedId: string, selectedValue: string];
        validAt: string;
        expiresAt: string;
        fileName?: string;
    };
    error?: string;
    approved?: boolean;
    educatorInputValue?: string;
    isFunctionGroupModalOpen?: boolean;
    isQualificationStandardModalOpen?: boolean;
    isOpenFormLoading: boolean;
}

const initialState: EditCertificateModalInterface = {
    isEditCertificateModalOpen: false,
    isPatchEditCertificateSuccess: false,
    isFunctionGroupModalOpen: false,
    isQualificationStandardModalOpen: false,
    isOpenFormLoading: false,
};

const editCertificateModalSlice = createSlice({
    name: "editCertificate",
    initialState,
    reducers: {
        setIsEditCertificateModalOpen: (state, action) => {
            state.isEditCertificateModalOpen = action.payload;
        },
        setIsPatchEditCertificateSuccess: (state, action) => {
            state.isPatchEditCertificateSuccess = action.payload;
        },
        setSelectedCertificateId: (state, action) => {
            state.selectedCertificateId = action.payload;
        },
        setFormValues: (state, action) => {
            state.formValues = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setApproved: (state, action) => {
            state.approved = action.payload;
        },
        setIsFunctionGroupModalOpen: (state, action) => {
            state.isFunctionGroupModalOpen = action.payload;
        },
        setIsQualificationStandardModalOpen: (state, action) => {
            state.isQualificationStandardModalOpen = action.payload;
        },
        setEducatorInputValue: (state, action) => {
            state.educatorInputValue = action.payload;
        },
        setIsOpenFormLoading: (state, action) => {
            state.isOpenFormLoading = action.payload;
        },
        resetFormValues: (state) => {
            state.formValues = undefined;
        },
    },
});

export const editCertificateModalReducer = editCertificateModalSlice.reducer;

export const {
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
    setFormValues,
    setError,
    setIsPatchEditCertificateSuccess,
    setApproved,
    setIsQualificationStandardModalOpen,
    setIsFunctionGroupModalOpen,
    setEducatorInputValue,
    setIsOpenFormLoading,
    resetFormValues,
} = editCertificateModalSlice.actions;
